
import { QueryClient } from "react-query";

export const defaultOffset = 800;
// export const BASE_URL="http://mjlisalshab.com/api/app/v1"
export const BASE_URL="https://mjlisalshab.com/api/app/v1"
export const BASE_WEB_URL="https://mjlisalshab.com/"
// export const BASE_URL="http://127.0.0.1:8000/api/app/v1"
// export const BASE_WEB_URL="http://127.0.0.1:8000/"
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
          cacheTime: 0, // Disable caching by setting cacheTime to 0
          staleTime: 0
        },
    }
})  